import { cn } from "@/lib/cn";
import { TONE, type Tone } from "./tones";

/** 강조 안내/에러 박스. */
export function Banner({
  tone = "danger",
  className,
  children,
}: {
  tone?: Tone;
  className?: string;
  children: React.ReactNode;
}) {
  const t = TONE[tone];
  return (
    <div
      className={cn("rounded-[12px] px-4 py-3 text-sm", className)}
      style={{ background: t.soft, color: t.fg }}
    >
      {children}
    </div>
  );
}
